import Cookies from 'js-cookie'
// cookie保存的天数
import config from '@/configs'
import { forEach, hasOneOf, objEqual } from '@/libs/tools'
// import store from '@/store'

export const TOKEN_KEY = 'token'

export const setToken = (token) => {
  session.put(TOKEN_KEY, token, { expires: config.cookieExpires || 1 })
}

export const getToken = () => {
  const token = localRead(TOKEN_KEY)
  if (token) return token
  else return false
}
export const setCookies = (key, value) => {
  Cookies.set(key, value, { expires: config.cookieExpires || 1 })
}

export const getCookies = (key) => {
  const value = Cookies.get(key)
  if (value) return value
  else return false
}

export const hasChild = (item) => {
  return item.children && item.children.length !== 0
}

const showThisMenuEle = (item, access) => {
  if (item.meta && item.meta.access && item.meta.access.length) {
    if (hasOneOf(item.meta.access, access)) return true
    else return false
  } else return true
}
/**
 * @param {Array} list 通过路由列表得到菜单列表
 * @returns {Array}
 */
export const getMenuByRouter = (list, access) => {
  let res = []
  forEach(list, item => {
    if (!item.meta || (item.meta && !item.meta.hideInMenu)) {
      let obj = {
        icon: (item.meta && item.meta.icon) || '',
        name: item.name,
        meta: item.meta
      }
      if ((hasChild(item) || (item.meta && item.meta.showAlways)) && showThisMenuEle(item, access)) {
        obj.children = getMenuByRouter(item.children, access)
      }
      if (item.meta && item.meta.href) obj.href = item.meta.href
      if (showThisMenuEle(item, access)) res.push(obj)
    }
  })
  return res
}

export const getMenuAllByRouter = (list, access) => {
  let res = []
  forEach(list, item => {
    if (!item.meta || (item.meta && !item.meta.hideInMenu) || authArr.includes(item.meta.title)) {
      let obj = {
        icon: (item.meta && item.meta.icon) || '',
        name: item.name,
        meta: item.meta
      }
      if ((hasChild(item) || (item.meta && item.meta.showAlways)) && showThisMenuEle(item, access)) {
        obj.children = getMenuAllByRouter(item.children, access)
      }
      if (item.meta && item.meta.href) obj.href = item.meta.href
      if (showThisMenuEle(item, access)) res.push(obj)
    }
  })
  return res
}
/**
 * @param {Array} routeMetched 当前路由metched
 * @returns {Array}
 */
export const getBreadCrumbList = (route, homeRoute) => {
  let homeItem = { ...homeRoute, icon: homeRoute.meta.icon }
  let routeMetched = route.matched
  if (routeMetched.some(item => item.name === homeRoute.name)) return [homeItem]
  let res = routeMetched.filter(item => {
    return item.meta === undefined || !item.meta.hide
  }).map(item => {
    let meta = { ...item.meta }
    if (meta.title && typeof meta.title === 'function') meta.title = meta.title(route)
    let obj = {
      icon: (item.meta && item.meta.icon) || '',
      name: item.name,
      meta: meta
    }
    return obj
  })
  res = res.filter(item => {
    return !item.meta.hideInMenu
  })
  return [{ ...homeItem, to: homeRoute.path }, ...res]
}

export const getRouteTitleHandled = route => {
  let router = { ...route }
  let meta = { ...route.meta }
  if (meta.title && typeof meta.title === 'function') meta.title = meta.title(router)
  router.meta = meta
  return router
}

export const showTitle = (item, vm) => vm.$config.useI18n ? vm.$t(item.name) : ((item.meta && item.meta.title) || item.name)

/**
 * @description 本地存储和获取标签导航列表
 */
export const setTagNavListInLocalstorage = list => {
  localStorage.tagNaveList = JSON.stringify(list)
}
/**
 * @returns {Array} 其中的每个元素只包含路由原信息中的name, path, meta三项
 */
export const getTagNavListFromLocalstorage = () => {
  const list = localStorage.tagNaveList
  return list ? JSON.parse(list) : []
}

/**
 * @param {Array} routers 路由列表数组
 * @description 用于找到路由列表中name为home的对象
 */
export const getHomeRoute = (routers, homeName = 'home') => {
  let i = -1
  let len = routers.length
  let homeRoute = {}
  while (++i < len) {
    let item = routers[i]
    if (item.children && item.children.length) {
      let res = getHomeRoute(item.children, homeName)
      if (res.name) return res
    } else {
      if (item.name === homeName) homeRoute = item
    }
  }
  return homeRoute
}

/**
 * @param {*} list 现有标签导航列表
 * @param {*} newRoute 新添加的路由原信息对象
 * @description 如果该newRoute已经存在则不再添加
 */
export const getNewTagList = (list, newRoute) => {
  const { name, path, meta } = newRoute
  let newList = [...list]
  if (newList.findIndex(item => item.name === name) >= 0) return newList
  else newList.push({ name, path, meta })
  return newList
}

/**
 * @param {*} access 用户权限数组，如 ['super_admin', 'admin']
 * @param {*} route 路由列表
 */
const hasAccess = (access, route) => {
  if (route.meta && route.meta.access) return hasOneOf(access, route.meta.access)
  else return true
}

/**
 * 权鉴
 * @param {*} name 即将跳转的路由name
 * @param {*} access 用户权限数组
 * @param {*} routes 路由列表
 * @description 用户是否可跳转到该页
 */
export const canTurnTo = (name, access, routes) => {
  const routePermissionJudge = (list) => {
    return list.some(item => {
      if (item.children && item.children.length) {
        return routePermissionJudge(item.children)
      } else if (item.name === name) {
        return hasAccess(access, item)
      }
    })
  }

  return routePermissionJudge(routes)
}

/**
 * @param {String} url
 * @description 从URL中解析参数
 */
export const getParams = url => {
  const keyValueArr = url.split('?')[1].split('&')
  let paramObj = {}
  keyValueArr.forEach(item => {
    const keyValue = item.split('=')
    paramObj[keyValue[0]] = keyValue[1]
  })
  return paramObj
}

/**
 * @param {Array} list 标签列表
 * @param {String} name 当前关闭的标签的name
 */
export const getNextRoute = (list, route) => {
  let res = {}
  if (list.length === 2) {
    res = getHomeRoute(list)
  } else {
    const index = list.findIndex(item => routeEqual(item, route))
    console.log(route, index, list.length)
    if (index === list.length - 1) res = list[list.length - 2]
    else res = list[index + 1]
  }
  return res
}

/**
 * @param {Number} times 回调函数需要执行的次数
 * @param {Function} callback 回调函数
 */
export const doCustomTimes = (times, callback) => {
  let i = -1
  while (++i < times) {
    callback(i)
  }
}

/**
 * @param {Object} file 从上传组件得到的文件对象
 * @returns {Promise} resolve参数是解析后的二维数组
 * @description 从Csv文件中解析出表格，解析成二维数组
 */
export const getArrayFromFile = (file) => {
  let nameSplit = file.name.split('.')
  let format = nameSplit[nameSplit.length - 1]
  return new Promise((resolve, reject) => {
    let reader = new FileReader()
    reader.readAsText(file) // 以文本格式读取
    let arr = []
    reader.onload = function (evt) {
      let data = evt.target.result // 读到的数据
      let pasteData = data.trim()
      arr = pasteData.split((/[\n\u0085\u2028\u2029]|\r\n?/g)).map(row => {
        return row.split('\t')
      }).map(item => {
        return item[0].split(',')
      })
      if (format === 'csv') resolve(arr)
      else reject(new Error('[Format Error]:你上传的不是Csv文件'))
    }
  })
}

/**
 * @param {Array} array 表格数据二维数组
 * @returns {Object} { columns, tableData }
 * @description 从二维数组中获取表头和表格数据，将第一行作为表头，用于在iView的表格中展示数据
 */
export const getTableDataFromArray = (array) => {
  let columns = []
  let tableData = []
  if (array.length > 1) {
    let titles = array.shift()
    columns = titles.map(item => {
      return {
        title: item,
        key: item
      }
    })
    tableData = array.map(item => {
      let res = {}
      item.forEach((col, i) => {
        res[titles[i]] = col
      })
      return res
    })
  }
  return {
    columns,
    tableData
  }
}

export const findNodeUpper = (ele, tag) => {
  if (ele.parentNode) {
    if (ele.parentNode.tagName === tag.toUpperCase()) {
      return ele.parentNode
    } else {
      return findNodeUpper(ele.parentNode, tag)
    }
  }
}

export const findNodeUpperByClasses = (ele, classes) => {
  let parentNode = ele.parentNode
  if (parentNode) {
    let classList = parentNode.classList
    if (classList && classes.every(className => classList.contains(className))) {
      return parentNode
    } else {
      return findNodeUpperByClasses(parentNode, classes)
    }
  }
}

export const findNodeDownward = (ele, tag) => {
  const tagName = tag.toUpperCase()
  if (ele.childNodes.length) {
    let i = -1
    let len = ele.childNodes.length
    while (++i < len) {
      let child = ele.childNodes[i]
      if (child.tagName === tagName) return child
      else return findNodeDownward(child, tag)
    }
  }
}

export const showByAccess = (access, canViewAccess) => {
  return hasOneOf(canViewAccess, access)
}

/**
 * @description 根据name/params/query判断两个路由对象是否相等
 * @param {*} route1 路由对象
 * @param {*} route2 路由对象
 */
export const routeEqual = (route1, route2) => {
  const params1 = route1.params || {}
  const params2 = route2.params || {}
  const query1 = route1.query || {}
  const query2 = route2.query || {}
  return (route1.name === route2.name) && objEqual(params1, params2) && objEqual(query1, query2)
}

/**
 * 判断打开的标签列表里是否已存在这个新添加的路由对象
 */
export const routeHasExist = (tagNavList, routeItem) => {
  let len = tagNavList.length
  let res = false
  doCustomTimes(len, (index) => {
    if (routeEqual(tagNavList[index], routeItem)) res = true
  })
  return res
}

export const localSave = (key, value) => {
  localStorage.setItem(key, value)
}

export const localRead = (key) => {
  return localStorage.getItem(key) || ''
}

/**
 * 删除cookie
 */
export const delCookie = (NameOfCookie) => {
  if (getCookies(NameOfCookie)) {
    document.cookie = NameOfCookie + '=' + '; expires=Thu, 01-Jan-70 00:00:01 GMT'
  }
}

/**
 * 数据验证
 */
export const setValidate = (vm, parameter, tips) => {
  if (parameter === null || parameter === undefined || parameter.length === 0 || parameter === '' || parameter === '[]' || parameter === '{}') {
    vm.$Message.error({ content: tips, closable: true, duration: 3 })
    return true
  }
  return false
}

/**
 * 时间转换
 * @param date
 * @returns {string}
 */
export const getNowDate = (date) => {
  return formatDate(date, 'yyyy-MM-dd')
}

/**
 * 格式化数据
 * @param date
 * @param fmt
 * @returns {*}
 */
export const formatDate = (date, fmt) => {
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  }
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + ''
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : ('00' + str).substr(str.length))
    }
  }
  return fmt
}

export const formatDate2 = (date, fmt) => {
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  }
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + ''
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : ('00' + str).substr(str.length))
    }
  }
  return fmt
}
/* 时间格式转换 2019-07-22T00:00:00.000+0800 转为 */
export const formatDate3 = (date, fmt) => {
  date = new Date(date)
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  }
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + ''
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : ('00' + str).substr(str.length))
    }
  }
  return fmt
}

export const getformatdate = (date) => {
  console.log(date)
  return date[0] + '-' + date[1] + '-' + date[2]
}

export const getNowFormatDate = () => {
  let date = new Date()
  let seperator1 = '-'
  let year = date.getFullYear()
  let month = date.getMonth() + 1
  let strDate = date.getDate()
  if (month >= 1 && month <= 9) {
    month = '0' + month
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = '0' + strDate
  }
  let currentdate = year + seperator1 + month + seperator1 + strDate
  return currentdate
}

/**
 * 匹配数据
 */
export const getMatchIng = (values, array) => {
  for (let i = 0; i < array.length; i++) {
    // console.log(array[i]['id'])
    // console.log(values)
    if (values === array[i]['id']) {
      return array[i]['compName']
    }
  }
}

/**
 * 日期比较
 */
export const tabDate = (date1, date2) => {
  let oDate1 = new Date(date1)
  let oDate2 = new Date(date2)
  if (oDate1.getTime() > oDate2.getTime()) {
    return true
  } else {
    return false
  }
}

/**
 * 时间戳格式化1
 * @param timestamp
 * @returns {string}
 */
export const timestampToTime = (timestamp) => {
  let date = new Date(timestamp * 1000)
  let Y = date.getFullYear() + '-'
  let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
  let D = date.getDate() + ' '
  // let h = date.getHours() + ':'
  // let m = date.getMinutes() + ':'
  // let s = date.getSeconds()
  return Y + M + D
}
export const timestampToTime3 = (timestamp) => {
  let date = new Date(timestamp)
  let Y = date.getFullYear() + '-'
  let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
  let D = date.getDate() + ' '
  // let h = date.getHours() + ':'
  // let m = date.getMinutes() + ':'
  // let s = date.getSeconds()
  return Y + M + D
}
/**
 * 时间戳格式化2
 * @param timestamp
 * @returns {string}
 */
export const timestampToTime2 = (timestamp) => {
  let date = new Date(timestamp)
  let Y = date.getFullYear() + '/'
  let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '/'
  let D = date.getDate() + ' '
  // let h = date.getHours() + ':'
  // let m = date.getMinutes() + ':'
  // let s = date.getSeconds()
  return Y + M + D
}
export const formatDateTime = (timeStamp) => {
  let date = new Date()
  date.setTime(timeStamp)
  let y = date.getFullYear()
  let m = date.getMonth() + 1
  m = m < 10 ? ('0' + m) : m
  let d = date.getDate()
  d = d < 10 ? ('0' + d) : d
  return y + '-' + m + '-' + d
}

export const formatNowDate = () => {
  let date = new Date()
  let y = date.getFullYear()
  let m = date.getMonth() + 1
  m = m < 10 ? ('0' + m) : m
  let d = date.getDate()
  d = d < 10 ? ('0' + d) : d
  return y + '-' + m + '-' + d
}

/**
*@author YNN
* 时间戳转换时分秒
*/
export const MillisecondToDate = (time, format) => {
  let t = new Date(time)
  let tf = function (i) { return (i < 10 ? '0' : '') + i }
  return format.replace(/HH|mm|ss/g, function (a) {
    switch (a) {
      case 'mm':
        return tf(t.getMinutes())
      case 'HH':
        return tf(t.getHours())
      case 'ss':
        return tf(t.getSeconds())
    }
  })
}
/**
*@author YNN
* 时间戳转换年月日
*/
// export const timestampToTime4 = (timestamp) => {
//   var date = new Date(timestamp)
//   Y = date.getFullYear() +'年';
//   M = (date.getMonth() +1 <10 ?'0' + (date.getMonth() +1) : date.getMonth() +1) +'月';
//   D = date.getDate() +'日';
//   h = date.getHours() +':';
//   m = date.getMinutes() +':';
//   s = date.getSeconds();
//   return Y +M +D;
// }

/**
 * 匹配数据
 */
export const getMatchAuth = (array) => {
  for (let i = 0; i < array.length; i++) {
    if (array[i]['authId']) {
      array[i]['title'] = array[i]['authName']
      if (hasChild(array[i])) {
        array[i].expand = true
        getMatchAuth(array[i]['children'])
      }
    }
  }
  return array
}

/**
 * 匹配数据
 */
export const getProductCatory = (array) => {
  for (let i = 0; i < array.length; i++) {
    if (array[i]['categoryId']) {
      array[i]['title'] = array[i]['categoryName']
      if (array[i]['children'].length === 0) {
        delete array[i]['children']
      }
      if (hasChild(array[i])) {
        getProductCatory(array[i]['children'])
      }
    }
  }
  return array
}

/**
 * 匹配数据
 */
export const setProductCatory = (array, categoryId) => {
  for (let i = 0; i < array.length; i++) {
    if (array[i]['categoryId']) {
      if (array[i]['categoryId'] === categoryId) {
        array[i]['checked'] = true
      }
      if (hasChild(array[i])) {
        setProductCatory(array[i]['children'], categoryId)
      }
    }
  }
  return array
}
/**
 * 匹配菜单数据
 */
let authArr = ['遗失补卡', '卡种变更', '会员退卡退费', '会员卡延期', '会员卡合并', '会员卡取消欠款', '会员卡停用启用']
export const setMatchmenu = (array, item, vm, type) => {
  let arrlist = []
  if (array && array.length > 0) {
    try {
      array.forEach((arr) => {
        if (item.meta.title === arr.authName || item.name === arr.authName) {
          if (hasChild(arr) && hasChild(item)) {
            let childArr = []
            item.children.forEach((child) => {
              arr.children.forEach((auth) => {
                if (child.meta.title === auth.authName || child.name === auth.authName) {
                  if (!child.meta.isChange) {
                    child.meta.isChange = true
                    childArr.push(setMatchmenu(arr['children'], child, vm, type))
                  }
                }
              })
            })
            arr['children'] = childArr
          } else {
            let hasDisabled = []
            let permission = []
            if (arr.buttonList && arr.buttonList.length > 0) {
              arr.buttonList.forEach((btn) => {
                // if (item.meta.hasDisabled && item.meta.hasDisabled.length > 0) {
                //   if (item.meta.hasDisabled.includes(btn.authCode)) {
                //     hasDisabled.push(btn.authCode)
                //   }
                // }
                hasDisabled.push(btn.authCode)
                // if (item.meta.permission && item.meta.permission.length > 0) {
                //   if (item.meta.permission.includes(btn.authCode)) {
                //     permission.push(btn.authCode)
                //   }
                // }
              })
            }
            // debugger
            item.meta.hasDisabled = hasDisabled
            item.meta.permission = permission
            if (type) {
              if (arr.fieldList && arr.fieldList.length > 0) {
                if (vm) {
                  let authSellOrder = Object.keys(vm.state.auth.authSellOrder)
                  let authRechargeOrder = Object.keys(vm.state.auth.authRechargeOrder)
                  let authConsumptionOrder = Object.keys(vm.state.auth.authConsumptionOrder)
                  let authTreatmentOrder = Object.keys(vm.state.auth.authTreatmentOrder)
                  let authTreatmentRetreatOrder = Object.keys(vm.state.auth.authTreatmentRetreatOrder)
                  arr.fieldList.forEach((field) => {
                    if (authSellOrder.includes(field.authCode)) {
                      vm.commit('setAuthSellOrder', field.authCode)
                    }
                    if (authRechargeOrder.includes(field.authCode)) {
                      vm.commit('setAuthRechargeOrder', field.authCode)
                    }
                    if (authConsumptionOrder.includes(field.authCode)) {
                      vm.commit('setAuthConsumptionOrder', field.authCode)
                    }
                    if (authTreatmentOrder.includes(field.authCode)) {
                      vm.commit('setAuthTreatmentOrder', field.authCode)
                    }
                    if (authTreatmentRetreatOrder.includes(field.authCode)) {
                      vm.commit('setAuthTreatmentRetreatOrder', field.authCode)
                    }
                  })
                  // authSellOrder
                  // authRechargeOrder
                  // authConsumptionOrder
                  // authTreatmentOrder
                  // authTreatmentRetreatOrder
                }
              }
            }
          }
          Object.assign(item, arr)
          if (item.meta && item.name) {
            arrlist.push(item)
          }
          throw Error('找到了')
        }
      })
    } catch (e) {
    }
  }
  if (item.children && item.children.length > 0) {
    return arrlist
  } else {
    return item
  }
}

/* 获取组织架构树形结构 */
export const getStructureTree = (array) => {
  if (array && array.length > 0) {
    array.forEach((item) => {
      item.title = item.label
      item.expand = true
      if (hasChild(item)) {
        getStructureTree(item.children)
      }
    })
  }
  return array
}
/**
 * 会员卡异常提醒
 */
export const vipError = (status, vm) => {
  let result = false
  if (status === 80101) {
    result = false
  } else if (status === 80120) {
    result = true
    vm.$Message.error({ content: '会员卡已禁用', closable: true, duration: 5 })
  } else if (status === 80121) {
    result = true
    vm.$Message.error({ content: '会员卡升级后禁用', closable: true, duration: 5 })
  } else if (status === 80122) {
    result = true
    vm.$Message.error({ content: '会员卡撤销购卡后禁用', closable: true, duration: 5 })
  } else if (status === 80123) {
    result = true
    vm.$Message.error({ content: '撤销异动后禁用', closable: true, duration: 5 })
  } else if (status === 80124) {
    result = true
    vm.$Message.error({ content: '撤销升级后禁用', closable: true, duration: 5 })
  } else if (status === 80140) {
    result = true
    vm.$Message.error({ content: '会员卡已挂失', closable: true, duration: 5 })
  } else if (status === 80141) {
    result = true
    vm.$Message.error({ content: '遗失后禁用', closable: true, duration: 5 })
  } else if (status === 80142) {
    result = true
    vm.$Message.error({ content: '卡种变更后禁用', closable: true, duration: 5 })
  } else if (status === 80143) {
    result = true
    vm.$Message.error({ content: '退卡后禁用', closable: true, duration: 5 })
  } else if (status === 80144) {
    result = true
    vm.$Message.error({ content: '退费后禁用', closable: true, duration: 5 })
  } else if (status === 80145) {
    result = true
    vm.$Message.error({ content: '合并后禁用', closable: true, duration: 5 })
  } else if (status === 80161) {
    result = true
    vm.$Message.error({ content: '撤销遗失补卡后禁用', closable: true, duration: 5 })
  } else if (status === 80162) {
    result = true
    vm.$Message.error({ content: '撤销卡种变更后禁用', closable: true, duration: 5 })
  } else if (status === 80164) {
    result = true
    vm.$Message.error({ content: '撤销退费后禁用', closable: true, duration: 5 })
  } else {
    result = true
    vm.$Message.error({ content: '会员卡状态异常，请联系总部！', closable: true, duration: 5 })
  }
  return result
}

/**
 * 日期区间对比
 */
export const getStartEndTime = (beginTime, endTime, vm) => {
  let result = false
  if (beginTime === '' || beginTime === null || beginTime === 'undefined') {
    vm.$Message.error({ content: '会员卡起始日期异常，请联系总部！', closable: true, duration: 5 })
    result = true
    return result
  }
  if (endTime === '' || endTime === null || endTime === 'undefined') {
    vm.$Message.error({ content: '会员卡终止日期异常，请联系总部！', closable: true, duration: 5 })
    result = true
    return result
  }

  let beginTimeFlag = dateParse(beginTime).getTime()
  let endTimeFlag = dateParse(endTime).getTime()
  let timeFlag = new Date().getTime()
  if (timeFlag < beginTimeFlag && timeFlag > endTimeFlag) {
    vm.$Message.error({ content: '会员卡已过期，请联系总部！', closable: true, duration: 5 })
    result = true
  }
  return result
}
/**
* 日期解析，字符串转日期
* @param dateString 可以为2017-02-16，2017/02/16，2017.02.16
* @returns {Date} 返回对应的日期对象
*/
export const dateParse = (dateString) => {
  let SEPARATOR_BAR = '-'
  let SEPARATOR_SLASH = '/'
  let SEPARATOR_DOT = '.'
  let dateArray = []
  if (dateString.indexOf(SEPARATOR_BAR) > -1) {
    dateArray = dateString.split(SEPARATOR_BAR)
  } else if (dateString.indexOf(SEPARATOR_SLASH) > -1) {
    dateArray = dateString.split(SEPARATOR_SLASH)
  } else {
    dateArray = dateString.split(SEPARATOR_DOT)
  }
  return new Date(dateArray[0], dateArray[1], dateArray[2])
}

/**
 * 获取 resInt 前的日期格式 (用于列表获取)
 * @param resInt
 */
export const getPreDate = (resInt) => {
  // 当前日期（含）
  if (resInt > 0) {
    resInt = resInt - 1
  }
  let nowDate = new Date()
  let preDate = new Date(nowDate.getTime() - 24 * 60 * 60 * 1000 * resInt)
  return formatDate(preDate, 'yyyy-MM-dd')
}

/**
 *
 * 判断日期是否在天数范围内
 * @param dateString  日期
 * @param resInt      天数
 * @returns {boolean}
 */
export const judgeDate = (dateString, resInt) => {
  let res = true
  // 当前日期（含）
  if (resInt > 0) {
    resInt = resInt - 1
  }
  let nowDate = new Date()
  let preDate = new Date(nowDate.getTime() - 24 * 60 * 60 * 1000 * resInt)
  dateString = dateString.replace(/-/g, '/')
  let dateTime = new Date(dateString)

  // 小于天数日期 或 大于当前日期，内容有问题

  if (dateTime.getTime() < preDate.getTime() || dateTime.getTime() > nowDate.getTime()) {
    res = false
  }

  return res
}

/**
 * 跳转页面
 * @param vm
 * @param urlName
 */
export const goToTag = (vm, urlName) => {
  // 如果当前打开页面是否在标签栏中
  if (!vm.$store.state.app.tagNavList.find(item => item.name === urlName)) {
    // 如果不在标签中直接打开
    vm.$router.push(urlName)
  } else {
    // 如果在标签中直接打开
    vm.$router.push({
      name: urlName
    })
  }
}

/**
 * 重录项目对比、提示
 * @param vm
 * @param project 原来的项目集合
 * @param projectArr 现在的项目集合
 * @param vipType 现在的项目集合
 */
export const getRerecordConsumptionOrderProject = (vm, project, projectArr, vipType) => {
  let rerecordProject = []
  // 重录项目
  if (project.length > 0 && projectArr.length > 0) {
    project.forEach((item) => {
      // 重录项目是否在
      let projectFalse = true
      projectArr.forEach((itemArr) => {
        if (itemArr.projectType === 61501 && item.projectId === itemArr.projectId) {
          projectFalse = false
        } else if (itemArr.projectType === 61502 && item.projectId === itemArr.projectId) {
          projectFalse = false
        } else if (itemArr.projectType === 61503 && item.projectId === itemArr.projectId) {
          projectFalse = false
        }
        if (itemArr.discountList === undefined) {
          itemArr.discountList = JSON.parse(itemArr.discountJson)
        }
        item.discountJson = itemArr.discountJson
        item.standardPrice = itemArr.standardPrice
        if (itemArr.unifiedVipPrice > 0) {
          item.price = itemArr.unifiedVipPrice / 100
          item.prize = itemArr.standardPrice / 100
          item.discountPrice = itemArr.unifiedVipPrice / 100
          item.amount = itemArr.unifiedVipPrice / 100
          item.unifiedVipPrice = itemArr.unifiedVipPrice
          item.isdiscountPriceDisabled = true
        } else {
          if (itemArr.discountList.length > 0 && !projectFalse) {
            itemArr.discountList.forEach((itemDiscount) => {
              if (item.vipAccount === 10324 && vipType !== null && itemDiscount.accountType === 81001 && itemDiscount.classId === vipType && itemDiscount.isDisabled === 0 && itemDiscount.relationId === item.projectId) {
                let amount = itemDiscount.defaultDiscount * item.prize
                let amountPic = (itemDiscount.defaultDiscount * item.prize * item.numbers).toFixed(0)
                amount = amount.toFixed(0)
                item.price = amount
                item.discount = itemDiscount.defaultDiscount
                item.discountPrice = amount
                item.amount = amountPic
              } else if (item.vipAccount === 10325 && vipType !== null && itemDiscount.accountType === 81002 && itemDiscount.classId === vipType && itemDiscount.isDisabled === 0 && itemDiscount.relationId === item.projectId) {
                let amount = itemDiscount.defaultDiscount * item.prize
                let amountPic = (itemDiscount.defaultDiscount * item.prize * item.numbers).toFixed(0)
                amount = amount.toFixed(0)
                item.price = amount
                item.discount = itemDiscount.defaultDiscount
                item.discountPrice = amount
                item.amount = amountPic
              }
            })
          }
        }
      })
      if (projectFalse) {
        projectArr.forEach((itemArr) => {
          if (itemArr.projectType === 61501 && item.projectId === itemArr.projectId) {
            vm.$Notice.open({ title: '项目重录警告！', desc: '项目' + item.projectName + '已被禁用，重录时无法录入该项目', duration: 0 })
          } else if (itemArr.projectType === 61503 && item.projectId === itemArr.projectId) {
            vm.$Notice.open({ title: '外部项目重录警告！', desc: '外部项目' + item.projectName + '已被禁用，重录时无法录入该项目', duration: 0 })
          }
        })
      } else {
        rerecordProject.push(item)
      }
    })
    return rerecordProject
  }
}

/**
 * 重录产品对比、提示
 * @param vm
 * @param product 原来的
 * @param productArr 现在的
 * @param vipType 会员卡ID
 */
export const getRerecordConsumptionOrderProduct = (vm, product, productArr, vipType) => {
  let rerecordProject = []
  // 重录项目
  if (product.length > 0 && productArr.length > 0) {
    product.map((item) => {
      // 重录产品是否在
      let projectFalse = true
      productArr.map((itemArr) => {
        if (item.productId === itemArr.productId) {
          projectFalse = false
          if (itemArr.discountList.length > 0) {
            itemArr.discountList.forEach((itemDiscount) => {
              if (vipType !== null && itemDiscount.accountType === 81001 && itemDiscount.classId === vipType && itemDiscount.isDisabled === 0 && itemDiscount.relationId === item.projectId) {
                let amount = itemDiscount.defaultDiscount * item.productPrice
                let amountPic = (itemDiscount.defaultDiscount * item.productPrice * item.productNums).toFixed(0)
                amount = amount.toFixed(0)
                item.productAllowancePrice = amount
                item.productDiscount = itemDiscount.defaultDiscount
                item.productAmount = amount
                item.amount = amountPic
              } else if (vipType !== null && itemDiscount.accountType === 81002 && itemDiscount.classId === vipType && itemDiscount.isDisabled === 0 && itemDiscount.relationId === item.projectId) {
                let amount = itemDiscount.defaultDiscount * item.productPrice
                let amountPic = (itemDiscount.defaultDiscount * item.productPrice * item.productNums).toFixed(0)
                amount = amount.toFixed(0)
                item.productAllowancePrice = amount
                item.productDiscount = itemDiscount.defaultDiscount
                item.productAmount = amount
                item.amount = amountPic
              }
            })
          }
        }
      })
      if (projectFalse) {
        vm.$Notice.open({ title: '产品重录警告！', desc: '产品' + item.productName + '已被禁用，重录时无法录入该项目', duration: 0 })
      } else {
        rerecordProject.push(item)
      }
    })
    return rerecordProject
  }
}

export class Coi {
  constructor (prop) {
    this.input = prop
    this.errorMessage = '通过校验' // 错误信息
    this.pass = true // 校验是否通过
  }

  // 数据输入
  data (input) {
    if (!this.pass) return this

    this.input = input
    return this
  }

  // 必填，不能为空
  isRequired (message) {
    if (!this.pass) return this

    if (
      /^\s*$/g.test(this.input) ||
      this.input === null ||
      this.input === undefined
    ) {
      this.errorMessage = message
      this.pass = false
    }
    return this
  }

  // 最小长度
  minLength (length, message) {
    if (!this.pass) return this

    if (this.input.length < length) {
      this.errorMessage = message
      this.pass = false
    }
    return this
  }

  // 最大长度
  maxLength (length, message) {
    if (!this.pass) return this

    if (this.input.length > length) {
      this.errorMessage = message
      this.pass = false
    }
    return this
  }

  // 需要的格式 number: 数字, letter: 字母, chinese: 中文
  requireFormat (formatArray, message) {
    if (!this.pass) return this
    let formatMap = {
      number: 0,
      letter: 0,
      chinese: 0
    }

    Object.keys(formatMap).forEach(key => {
      if (formatArray.includes(key)) formatMap[key] = 1
    })

    let formatReg = new RegExp(
      `^[${formatMap.number ? '0-9' : ''}${
        formatMap.letter ? 'a-zA-Z' : ''
      }${formatMap.chinese ? '\u4e00-\u9fa5' : ''}]*$`
    )

    if (!formatReg.test(this.input)) {
      this.errorMessage = message
      this.pass = false
    }
    return this
  }

  // 邮箱校验
  isEmail (message) {
    if (!this.pass) return this

    const emailReg = /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/
    if (!emailReg.test(this.input)) {
      this.errorMessage = message
      this.pass = false
    }
    return this
  }

  // 手机号校验
  isPhone (message) {
    if (!this.pass) return this

    const phoneReg = /^(((13[0-9])|(14[0-7])|(15[0-9])|(16[0-9])|(17[0-9])|(18[0-9])|(19[0-9]))+\d{8})$/
    if (!phoneReg.test(this.input)) {
      this.errorMessage = message
      this.pass = false
    }
    return this
  }

  // ulr校验
  isURL (message) {
    if (!this.pass) return this

    const urlReg = new RegExp(
      '^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$',
      'i'
    )
    if (!urlReg.test(this.input)) {
      this.errorMessage = message
      this.pass = false
    }
    return this
  }

  // 自定义正则校验
  requireRegexp (reg, message) {
    if (!this.pass) return this

    if (!reg.test(this.input)) {
      this.errorMessage = message
      this.pass = false
    }
    return this
  }
}

export const goOut = () => {
  // session.clearAll()
  localStorage.removeItem('userInfo')
  localStorage.removeItem('token')
  window.location.reload()
}
// 防抖
// time: 时间间隔
// func:  执行函数
let timer = null
export function debounce (func, time) {
  if (timer) {
    clearTimeout(timer)
  }
  timer = setTimeout(() => {
    func && func()
    clearTimeout(timer)
  }, time || 300)
}
/* 操作session */
export const session = {
  // 存储单个属性
  put: function (key, value) {
    window.sessionStorage[key] = value
  },
  // 读取单个属性
  get: function (key, defaultValue) {
    return window.sessionStorage[key] || defaultValue
  },
  // 存储对象
  putObject: function (key, value) {
    window.sessionStorage[key] = JSON.stringify(value)
  },
  // 读取对象
  getObject: function (key) {
    return JSON.parse(window.sessionStorage[key] || '{}')
  },
  // 清空
  clearAll: function () {
    window.sessionStorage.clear()
  }
}

/* 获取门店名称 */
export function getShopName (id) {
  let shopList = {}
  if (session.getObject('allShopList').length > 0) {
    session.getObject('allShopList').map((shop) => {
      shopList[shop.shopId] = shop.shopName
    })
    return shopList[id]
  } else {
    return '--'
  }
}
/* 获取页面路径参数 */
export const searchObj = search => JSON.parse(`{"${decodeURIComponent(search.substring(1)).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"')}"}`)
/* 对象转 url 查询字符串 */
export const objectToQueryString = (obj) => Object.keys(obj).map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`).join('&')
/* 将数字转化为千分位格式 */
export const toDecimalMark = num => num.toLocaleString('en-US')
/* 多维数组转一维数组 */
export const deepFlatten = arr => [].concat(...arr.map(v => (Array.isArray(v) ? deepFlatten(v) : v)))
